document.addEventListener(
  "click",
  function (event) {
    var link = event.target.closest("a[data-video-url]");
    if (!link) return;

    var videoUrl = link.dataset.videoUrl;
    if (!videoUrl) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    var poster = link.querySelector(".bp-video-poster, img");
    var posterSrc = poster ? poster.getAttribute("src") : null;

    var video = document.createElement("video");
    video.src = videoUrl;
    video.controls = true;
    video.autoplay = true;
    video.playsInline = true;
    video.className = "bp-video-player";
    if (posterSrc) video.poster = posterSrc;

    var playerWrapper = document.createElement("div");
    playerWrapper.className = "bp-video-blob-wrapper";
    playerWrapper.appendChild(video);

    var figure = link.closest("figure.attachment");
    if (figure) {
      var caption = figure.querySelector("figcaption.attachment__caption");
      figure.replaceChildren(playerWrapper);
      if (caption) figure.appendChild(caption);
    } else {
      link.replaceWith(playerWrapper);
    }

    var playPromise = video.play();
    if (playPromise && typeof playPromise.catch === "function") {
      playPromise.catch(function () {});
    }
  },
  true
);
